var toString = Object.prototype.toString

module.exports = isString

function isString(obj) {
    return toString.call(obj) === "[object String]"
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/x-is-string/index.js
// module id = 553
// module chunks = 0 15 16 17 18